<template>
  <generic-modal :title="$t('assistant request')" ref="generic_modal">
    <form>
      <div class="field">
        <label class="label">{{ $t("prompt") }}</label>
        <div class="control has-icons-left has-icons-right">
          <input
            class="input"
            type="text"
            :placeholder="$t('enter your prompt here')"
            v-model="meta.prompt"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-terminal"></i>
          </span>
          <span class="icon is-small is-right">
            <i class="fa fa-send"></i>
          </span>
        </div>
        <!-- <p class="help is-success">This username is available</p>
        <div class="control">
          <input class="input" type="text" v-model="meta.prompt" />
        </div> -->
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "RequestModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.prompt /* || !v.meta.sale_price */;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    // edit_modal(uuid) {
    //   let v = this;
    //   v.set_initial_state();

    //   get("/assistant/request", { uuid: uuid })
    //     .then((element) => {
    //       v.meta = element;
    //       v.$refs.generic_modal.show_modal();
    //     })
    //     .catch((error) => {
    //       v.error = generate_error_message_text(error);
    //     });
    // },
    save() {
      let v = this;
      // if (!v.meta.uuid)
      put("/assistant/request", v.meta)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      // else
      //   post("/assistant/request", v.meta)
      //     .then(() => {
      //       v.$emit("success");
      //       v.$refs.generic_modal.close_modal();
      //     })
      //     .catch((error) => {
      //       v.error = generate_error_message_text(error);
      //     });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        prompt: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
